<!DOCTYPE html>
<html lang="en">

<head>
    <title>Edit Monthly Volumes</title>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
</head>

<body>
<!-- Processing Overlay Start -->
<div *ngIf="isProcessing" class="processing-overlay">
    <div class="processing-box">
        <p-progressSpinner></p-progressSpinner>
        <p class="processing-text">
            Processing files... This may take a few seconds.
        </p>
    </div>
</div>
<!-- Processing Overlay End -->

    <div class="card-pad m-t-30">

        <div class="fr-flex__container sticky-sub-header">

            <div class="fr-flex__col-6">
                <h3>Edit Monthly Volumes</h3>
            </div>
             <div class="fr-flex__col-6">  
         <div class="preview_section pull-right">
            <button  [class.previous]="currentIndex !== 0"  (click)="pageChangeConfirmation(2)" [disabled]="currentIndex === 0"><i class="pi pi-arrow-up" pTooltip="Preview" tooltipPosition="top"></i></button>
            <span class="numbers_list">{{getCurrentPositionText()}}</span>
            <button [class.next]="currentIndex !== listOfVolumes.length - 1" (click)="pageChangeConfirmation(1)"  [disabled]="currentIndex === listOfVolumes.length - 1"><i class="pi pi-arrow-down" pTooltip="Next" tooltipPosition="top"></i></button>
            </div> 
      </div>
        </div>


        <form [formGroup]="volumeForm" class="scroll-start-here-sub-tabs">

            <div class="fr-flex__container m-t-20">
                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label>Month</label>
                         <input type="text" class="form-control read-only" pInputText value="{{ volumeDetail?.volumeDate | date:'MMMM yyyy' }}" readonly="readonly"/>
                    </div>
                </div>

                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label>Invoice Amount</label>
                         <p-inputNumber *ngIf="volumeDetail" class="form-control read-only" formControlName="_volumeAmount" inputId="minmaxfraction" mode="decimal" [minFractionDigits]="2" class="form-control-inputNumber read-only-value-condication" type="text" [maxlength]="15" [(ngModel)]="volumeDetail.invoiceAmount" [readonly]="true"/>
                    </div>
                </div>

                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label>Volume Update Status</label>
                          <input type="text" class="form-control read-only" pInputText [value]="volumeDetail?.statusName" readonly="readonly" />
                    </div>
                </div>
            </div>

            <div class="fr-flex__container">
 
                <div class="fr-flex__col-4">
                    <div class="fr-form__group">
                        <label>
                            Product Applicability <em>*</em>
                        </label>
 
                        <div style="display:flex; align-items:center; gap:28px; margin-top:8px;">
 
                            <div style="display:flex; align-items:center; gap:6px;">
                                <p-radioButton name="productApplicable" [value]="true"
                                    formControlName="productApplicable" (onClick)="changeProductApplicable(true)">
                                </p-radioButton>
                                <label>Yes</label>
                            </div>
 
                            <div style="display:flex; align-items:center; gap:6px;">
                                <p-radioButton name="productApplicable" [value]="false"
                                    formControlName="productApplicable" (onClick)="changeProductApplicable(false)">
                                </p-radioButton>
                                <label>No</label>
                            </div>
 
                        </div>
                    </div>
                </div>
 
 
                <div class="fr-flex__col-4" *ngIf="productApplicability">
                    <div class="fr-form__group">
                        <label>
                           Data Entry Method <em>*</em>
                        </label>
 
                        <div style="display:flex; align-items:center; gap:28px; margin-top:8px;">
 
                            <div style="display:flex; align-items:center; gap:6px;">
                                <p-radioButton name="entryMethod" value="Upload" formControlName="entryMethod"
                                    (onClick)="changeEntryMethod('Upload')">
                                </p-radioButton>
                                <label>Upload File</label>
                            </div>
 
                            <div style="display:flex; align-items:center; gap:6px;">
                                <p-radioButton name="entryMethod" value="Manual" formControlName="entryMethod"
                                    (onClick)="changeEntryMethod('Manual')">
                                </p-radioButton>
                                <label>Manual Entry</label>
                            </div>
 
                        </div>
                    </div>
                </div>
 
 
                <div class="fr-flex__col-4">
                </div>
 
            </div>
 

         <div *ngIf="!productApplicability" class="fr-flex__col-8 m-b-20">
            <div class="note-display-blue">
              <i class="pi pi-info-circle"></i>
              <span>
                Since work is not Product Specific, this invoice amount will not be attributed towards any Products.
              </span>
            </div>
          </div>
       

    <div *ngIf="productApplicability">

                <div class="fr-flex__container" *ngIf="mode == 'Upload'">
                    <div class="fr-flex__col-12">
                        <div class="fr-form__group" style="margin: 0 0 8px 0;">
                            <div style="display:flex; flex-direction:row; align-items:center; margin:0px; gap:10px;">
                                 <label style="display: inline-flex; align-items: center; gap: 4px;">
                                Attachments
                                <i pInputText pTooltip="Maximum 20 Attachments allowed." tooltipPosition="top"
                                    class="pi pi-info-circle"></i>
                                </label>
 
                                 <h5 class="note-display">
                                    <span>Note:</span> Please upload data only for the selected month. Also ensure the column containing product names is labeled “Product” or “Product Name”, and that column headers appear in the first row of the sheet.
                                </h5>
                            </div>
                            <div style="display:flex; align-items:center; gap:10px; width:100%;">
 
                                <input type="file" accept=".pdf, .xls, .xlsx,.doc,.docx" multiple
                                    (change)="onFileChange($event)" class="form-control" formControlName="_volumeFile"
                                    #fileInput style="display:none" trimSpace
                                    [ngClass]="{'read-only-dropdown':isDisabled}" [readonly]="isDisabled" />
 
                                <button type="button" (click)="fileInput.click()" class="form-control"
                                    style="height:38px; width:180px; margin-top:8px;"
                                    [disabled]="isUploadButtonDisabled || isDisabled">
                                    Upload Files
                                </button>
 
                                <button class="btn btn-primary" (click)="processUploads()" style="height:38px;"
                                    [disabled]="isProcessClicked">
                                    Process Uploads
                                </button>
 
                            </div>
                            <div *ngIf="uploadedFiles.length !== 0">
                                <div class="display-inline-block" *ngFor="let file of uploadedFiles">
                                    <a class="form-list-active" (click)="downloadAttachment(file)">
                                        <span [pTooltip]="file.name.length > 40 ? file.name : ''" tooltipPosition="top">
                                            {{ file.name | truncate: 40
                                            }} </span>
                                        <i *ngIf="!isDisabled" pInputText pTooltip="Delete" tooltipPosition="top"
                                            (click)="removeFile(file)" class="pi pi-trash"></i>
                                    </a>
                                </div>
                            </div>
 
                        </div>
 
                    </div>
                </div>
 
                <div *ngIf="mode==='Upload'" class="fr-flex__container fr-flex__col-12">
 
                    <div class="fr-flex__container align-items-center" style="width:100%;">
 
                        <div class="fr-flex__col-4" style="padding-left:0px;">
                            <div class="fr-form__group" style="margin:0;">
                                <div class="search-input-wrapper">
 
                                    <i class="pi pi-search"></i>
 
                                    <input
                                        type="text"
                                        class="form-control"
                                        pInputText
                                        placeholder="Search Product"
                                        [(ngModel)]="searchText"
                                        (ngModelChange)="filterUploadProducts()"
                                        [ngModelOptions]="{ standalone: true }"
                                        style="padding-left:34px; padding-right:30px;" />
 
                                    <i
                                        class="pi pi-times"
                                        *ngIf="searchText"
                                        (click)="clearUploadFilter()">
                                    </i>
 
                                </div>
                            </div>
                        </div>
 
                        <div class="fr-flex__col-3" style="display:flex; align-items:center; gap:4px;">
                            <p-checkbox
                                inputId="overrideCheck"
                                [(ngModel)]="isOverrideEnabled"
                                [binary]="true"
                                [disabled]="!uploadData || uploadData.length === 0"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="onOverrideChange()"
                                [style]="{ transform: 'scale(1.5)' }">
                            </p-checkbox>
 
                            <label for="overrideCheck" style="margin:0;">
                                Override System Calculation
                            </label>
                        </div>
 
                        <div class="fr-flex__col-5" style="display:flex; align-items:center; justify-content:flex-end;">
                            <h4 class="note-display m-b-0" style="margin:0;" *ngIf="isOverrideEnabled">
                                <span>Note :</span>
                                Total Product Percentage Attribution must be 100% to save.
                            </h4>
                        </div>
 
                    </div>
                    <div class="m-b-20 m-t-6">
 
                        <p-table #dt class="primeng-table-custom table-center-all m-t-4" [value]="filterUploadData"
                            [resizableColumns]="true" columnResizeMode="expand"
                            styleClass="p-datatable-striped p-datatable-gridlines" [scrollable]="true"
                            #contractDataTable [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50,100,200]"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
                            [showCurrentPageReport]="true" >
 
                            <ng-template pTemplate="header">
                                <tr>
                                    <th rowspan="2" style="text-align: center;">Product</th>
                                    <th colspan="2" style="text-align: center;">System Calculated</th>
                                    <th colspan="2" style="text-align: center;">Overwritten</th>
                                </tr>
                                <tr>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;">Units Of
                                        the Month</th>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;">Cost of
                                        the Month</th>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;"> % Cost
                                        Attribution ({{ totalOverridePercentage }}%)</th>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;"> Cost of
                                        the Month</th>
                                </tr>
                            </ng-template>
 
                            <ng-template pTemplate="body" let-rowData>
                                <tr>
                                    <td [pTooltip]="getProductDetails(rowData)" tooltipPosition="top"
                                        class="pointer-cursor" style="text-align: center;">{{ rowData.product }}</td>
                                    <td>{{ rowData.systemUnits }}</td>
                                    <td>{{ rowData.systemCost }}</td>
                                    <td style="padding: 1px;">
                                        <p-inputNumber [(ngModel)]="rowData.overwrittenCostAttribution"
                                            [disabled]="!isOverrideEnabled" mode="decimal" [minFractionDigits]="2"
                                            [maxFractionDigits]="2" [useGrouping]="false"
                                            [ngModelOptions]="{ standalone: true }"
                                            (keydown.enter)="commitUploadPercentage(rowData); $event.preventDefault()"
                                            (onBlur)="commitUploadPercentage(rowData); $event.preventDefault()">
                                        </p-inputNumber>
                                    </td>
                                    <td>{{ rowData.overwrittenCost }}</td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="footer">
                                <tr style="height: 26px; padding: 0px; border: 0px;">
                                    <td style="padding: 0px; border: 0px;"></td>
                                    <td style="padding: 0px; border: 0px;"></td>
                                   <td style="padding: 0; text-align: center; border: 0px;">
  <span style="font-size: 12px; line-height: 1;">
    Total Overwritten Percentage
  </span>
</td>
                                    <td style="padding: 0; text-align: center; border: 0px;"> <span style="font-size: 12px; line-height: 1;">{{ totalOverridePercentage }}% </span></td>
                                    <td style="padding: 0px; border: 0px;"></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>

        <div *ngIf="mode==='Manual'" class="fr-flex__container">
                    <div class="fr-flex__col-12"
                        style="margin:0px; display:flex; justify-content:space-between; align-items:center;">
 
                        <div class="pull-left fr-flex__col-4" style="margin: 0px; padding: 0px;">
                            <div class="fr-form__group" style="margin:0;">
                                <div class="search-input-wrapper">
 
                                    <i class="pi pi-search"></i>
 
                                    <input type="text" class="form-control" pInputText placeholder="Search Product" [(ngModel)]="searchText" (ngModelChange)="filterProducts()" [ngModelOptions]="{ standalone: true }"  style="padding-left:34px; padding-right:30px;" />
                                    <i class="pi pi-times" *ngIf="searchText" (click)="clearFilter()"></i>
                                </div>
                            </div>
                        </div>
 
                        <div class="pull-right align-items-center gap-4">
 
                            <div class="fr-flex__container" style="margin:0px;">
                                <div>
                                    <h4 class="note-display" style="margin:0px;">
                                        <span>Note :</span> Total Product Percentage Attribution must be 100% to save.
                                    </h4>
                                </div>
                            </div>
 
                        </div>
 
                    </div>
 
                    <div class="fr-flex__col-12 m-b-20 m-t-6">
                        <p-table #dt class="primeng-table-custom" [resizableColumns]="true"
                            columnResizeMode="expand" styleClass="p-datatable-striped p-datatable-gridlines"
                            [value]="filteredManualTableData" [scrollable]="true" [paginator]="true" [rows]="10"
                            [rowsPerPageOptions]="[10,20,50,100,200]"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Entries"
                            [showCurrentPageReport]="true">
 
                            <ng-template pTemplate="header">
                                <tr>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;">Product
                                        Name</th>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;">% Cost
                                        Attribution ({{
                                        totalAllocatedPercentage }}%)</th>
                                    <th pFrozenColumn pResizableColumn pInputText style="text-align: center;"> Cost
                                    </th>
                                </tr>
                            </ng-template>
 
                            <ng-template pTemplate="body" let-rowData>
                                <tr>
                                    <td [pTooltip]="getProductDetails(rowData)" tooltipPosition="top"
                                        class="pointer-cursor" style="text-align: center;">
                                    {{ rowData.productName }}
                                    </td>

                                    <td style="padding: 0px; text-align: center;">
                                    <p-inputNumber [(ngModel)]="rowData._tempPercentage" mode="decimal"
                                        [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="false"
                                        (keydown.enter)="commitPercentage(rowData)"
                                        (onBlur)="commitPercentage(rowData)"
                                        [ngModelOptions]="{ standalone: true }">
                                    </p-inputNumber>
                                    </td>

                                    <td style="padding: 0px; text-align: center;">
                                    {{ rowData.cost }}
                                    </td>
                                </tr>
                            </ng-template>
 
                            <ng-template pTemplate="footer">
                                <tr>
                                    <td style="text-align: center;"><strong>Total</strong></td>
                                    <td style="text-align: center;">{{ totalAllocatedPercentage }}%</td>
                                    <td></td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </div>
 
             </div>
        </form>


   <div class="fr-flex__container fr-flex__col-12">
              <div class="fr-flex__col-3">
               <div class="fr-form__view">
                  <label> Modified By <em> * </em></label>
                  <span> <em> {{updatedBy || '--'}}  </em></span>
                
               </div>
            </div>
            <div class="fr-flex__col-3">
               <div class="fr-form__view">
                  <label> Modified Date & Time <em> * </em></label>
                  <span *ngIf="volumeDetail?.updatedBy != null"> <em> {{volumeDetail?.updatedDate | date: _dateformart.DateTimeWithZone}}  {{_dateformart.DisplayUTC}}</em></span>
                  <span *ngIf="volumeDetail?.updatedBy==null"> <em> --</em></span>
               </div>
            </div> 
    </div>
    <div class="fr-flex__container footer_btns">
        <div class="fr-flex__col-12">
            <button routerLinkActive="active" type="button" class="btn btn-primary btn-save pull-right"
           [disabled]="productApplicability && ((mode==='Manual' && totalAllocatedPercentage!== 100) || (mode==='Upload' && isOverrideEnabled && totalOverridePercentage !== 100)|| (mode==='Upload' && uploadData.length === 0)) ||(mode=='Upload' && !isProcessClicked)"
            (click)="isSaveBtnDisable ? null : saveContractVolume()"> Save </button>
           <button type="button" class="btn btn-secondary pull-right" (click)="onCancelContractVolume()" > Cancel </button>
         </div>
    </div>

    </div>
</body>

</html>
